import React from 'react';
import AnalyticsCard from 'design-system/AnalyticsCard';
const IncomeSpendingAnalyticsCard = ({ large, incomePercent = 100, spendingPercent = 80, }) => (<AnalyticsCard large={large} leftBarPercent={incomePercent} leftBarGradientKey="turquoise" rightBarPercent={spendingPercent} rightBarGradientKey="deepPink" useRem/>);
export default IncomeSpendingAnalyticsCard;
